<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
      <p class="bread-crumbs">Pagos de servicios</p>
      <h2 class="">Listado de Pagos de servicios</h2>
    </div>
  </div>
  
  <div class="content-block">
    <div class="dx-card responsive-paddings pt-2">
      <!-- Filters -->
      <div class="">
        <!---->
        <dx-form [(formData)]="filtros" [colCount]="4" labelLocation="top">

                <!-- companyId -->
          <ng-container>
            <dxi-item dataField="companyId" editorType="dxSelectBox" [editorOptions]="{ displayExpr: 'companyName', valueExpr:'id', items: companies, searchEnabled: true, value: null }">
              <dxo-label text="Empresa"></dxo-label>
            </dxi-item>
          </ng-container>

           <!-- Date Start -->
          <dxi-item dataField="dateStart" dataType="date" [isRequired]="false">
            <dxo-label text="Fecha Inicio"></dxo-label>
            <dx-date-box displayFormat="shortdate" type="date" [(value)]="filtros.dateStart"
              (onValueChanged)="getPagos($event)">
              <dx-validator>
                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
          </dxi-item>
  
          <!-- Date End -->
          <dxi-item dataField="dateEnd" dataType="date" [isRequired]="false">
            <dxo-label text="Fecha Fin"></dxo-label>
            <dx-date-box displayFormat="shortdate" type="date" [(value)]="filtros.dateEnd"
              (onValueChanged)="getPagos($event)">
              <dx-validator>
                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
              </dx-validator>
            </dx-date-box>
          </dxi-item>
  
          <dxi-item>
            <div class="flex justify-content-center">
              <dx-button text="Buscar" icon="find" type="default" (onClick)="getPagos()"></dx-button>
            </div>
          </dxi-item>
   
        </dx-form>
  
      </div>
    </div>
  </div>
  <div class="content-block">
    <div class="dx-card responsive-paddings pt-2">
  
      <!-- Results -->
      <div class="mt-5">
        <dx-data-grid [dataSource]="pagos" keyExpr="id" [showBorders]="true" [columnAutoWidth]="true" [allowColumnResizing]="true">
          <dxo-export [enabled]="true" [allowExportSelectedData]="true" fileName="Reporte de Pagos de Servicios Generales"></dxo-export>
          <dxo-load-panel [enabled]="true"></dxo-load-panel>
          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 25, 50, 100]" [showInfo]="true">
          </dxo-pager>
          <dxi-column dataField="fecha_venta" dataType="date" format="dd/MM/yyyy hh:mm a" caption="Fecha de pago" alignment="center"></dxi-column>
          <dxi-column dataField="nombre_empresa" caption="Empresa" alignment="center"></dxi-column>
          <dxi-column dataField="nombre_cliente" caption="Usuario" alignment="center"></dxi-column>
          <dxi-column dataField="nombre_servicio" caption="Pago de servicio" alignment="center"></dxi-column>
          <dxi-column dataField="referencia" caption="Referencia" alignment="center"></dxi-column>
          <dxi-column dataField="no_autorizacion" caption="Autorización" alignment="center" [width]="110"></dxi-column>
          <dxi-column dataField="monto" caption="Monto" dataType="number" format="currency" alignment="center" [width]="150">
            <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
          </dxi-column>
          <dxi-column dataField="comision" caption="Comisión" dataType="number" format="currency" alignment="center" [width]="150">
            <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
          </dxi-column>
          <dxi-column dataField="total" caption="Total" dataType="number" format="currency" alignment="center" [width]="100" cellTemplate="totalTemplate">
            <dxo-format type="currency" [precision]="2"></dxo-format>
          </dxi-column>
          <div *dxTemplate="let t of 'totalTemplate'">
            <div> {{t.data.comision + t.data.monto | currency}}</div>
          </div>
          <dxo-summary>
            <dxi-total-item column="no_autorizacion" valueFormat="currency" displayFormat="Total : ">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
            </dxi-total-item>
            <dxi-total-item column="monto" summaryType="sum" valueFormat="currency" displayFormat="{0}">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
            </dxi-total-item>
            <dxi-total-item column="comision" summaryType="sum" valueFormat="currency" displayFormat="{0}">
              <dxo-value-format type="currency" [precision]="2"></dxo-value-format>
            </dxi-total-item>
          </dxo-summary>
        </dx-data-grid>
      </div>
    </div>
  </div>